import { styled } from '@mui/material/styles'
import Toolbar from '@mui/material/Toolbar'

const StyledToolbar = styled(Toolbar)({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  padding: '0 24px',
  minHeight: '60px',
  gap: 8,
})

export default StyledToolbar
